import { render, staticRenderFns } from "./viewPage.vue?vue&type=template&id=45fb310c&scoped=true"
import script from "./viewPage.vue?vue&type=script&lang=js"
export * from "./viewPage.vue?vue&type=script&lang=js"
import style0 from "./viewPage.vue?vue&type=style&index=0&id=45fb310c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fb310c",
  null
  
)

export default component.exports